export default __webpack_public_path__ + "static/media/ea_init.20d11908.png";